import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TranslatePipe } from '../../translate/translate.pipe';
import { TranslateService } from '../../translate/translate.service';
import { DocumentoDTO } from '../models/documento-dto';
import { StatoDocumentoDTO } from '../models/stato-documento-dto';
import { saveAs } from "file-saver";
import { ConfigurationService } from '../../configuration/configuration-service';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Documentale } from '../models/documentale';

type ColonneTabellaAllegati = {
	chiave: string,
	descrizione: string,
	visibile: boolean
}
@Component({
	selector: 'lib-allegati',
	templateUrl: './allegati.component.html',
	styleUrls: ['./allegati.component.css']
})
export class AllegatiComponent implements OnInit {

	loadingLinguage: boolean;
	documentoDownload$ = new Subject<any>();
	documentaleServiceUrl: string;
	dettaglio: boolean;
	documentoSelezionato: Documentale;
	dataJson: any;

	@Input()
	allegati: Array<Documentale> = [];

	@Input()
	visualizzaDettagli: boolean;

	@Input()
	colonne: Array<ColonneTabellaAllegati> = [];

	@Output() public dettaglioDoc = new EventEmitter<boolean>();

	cl1: boolean = false;
	cl2: boolean = false;
	cl3: boolean = false;
	cl4: boolean = false;
	cl5: boolean = false;
	cl6: boolean = false;
	cl7: boolean = false;
	cl8: boolean = false;

	constructor(private translateService: TranslateService,
		private translatePipe: TranslatePipe,
		private http: HttpClient,
		private configurationService: ConfigurationService) { }

	ngOnInit(): void {
		this.documentaleServiceUrl = this.configurationService.servicePaths.get('DOCUMENTALE_MS_API_URL');
		this.translatePipe.transform('');
		this.translateService.traduzioniLib$
			.pipe(
				tap(_ => _ ? this.loadingLinguage = true : null)
			)
			.subscribe();

		// console.log('[colonne]', this.colonne);
		this.cl1 = this.colonne.find(tipoServizio => tipoServizio.chiave == "colonna_allegati_1").visibile;
		this.cl2 = this.colonne.find(tipoServizio => tipoServizio.chiave == "colonna_allegati_2").visibile;
		this.cl3 = this.colonne.find(tipoServizio => tipoServizio.chiave == "colonna_allegati_3").visibile;
		this.cl4 = this.colonne.find(tipoServizio => tipoServizio.chiave == "colonna_allegati_4").visibile;
		this.cl5 = this.colonne.find(tipoServizio => tipoServizio.chiave == "colonna_allegati_5").visibile;
		this.cl6 = this.colonne.find(tipoServizio => tipoServizio.chiave == "colonna_allegati_6").visibile;
		this.cl7 = this.colonne.find(tipoServizio => tipoServizio.chiave == "colonna_allegati_7").visibile;
		this.cl8 = this.colonne.find(tipoServizio => tipoServizio.chiave == "colonna_allegati_8").visibile;
		// console.log('[colonne] - cl1', this.cl1);
		// console.log('[colonne] - cl2', this.cl2);
		// console.log('[colonne] - cl3', this.cl3);
		// console.log('[colonne] - cl4', this.cl4);
		// console.log('[colonne] - cl5', this.cl5);
		// console.log('[colonne] - cl6', this.cl6);
		// console.log('[colonne] - cl7', this.cl7);
		// console.log('[colonne] - cl8', this.cl8);
	}

	downloadFile(documento: DocumentoDTO) {
		const url: string = this.documentaleServiceUrl + documento.url;
		console.log('[url]', url);
		const headers = new HttpHeaders();
		headers.append('Accept', 'text/plain');
		this.http.get(url, { headers: headers, responseType: 'blob' }).subscribe(response => this.saveFile(response, documento.nome))
	}

	saveFile(response, nomeFile) {
		const blob = new Blob([response], { type: 'text/plain' });
		saveAs(blob, nomeFile);
	}

	isValid(stato: Array<StatoDocumentoDTO>) {
		if (stato.filter(s => s.lastState == true)) {
			return true;
		} else {
			return false;
		}
	}

	visualizzaDettaglio(allegato) {
		this.visualizzaDettagli = true;
		try {
			this.dataJson = JSON.parse(allegato.jsonMetadati);
		}
		catch (e) {
			this.dataJson = null;
			console.log('[error occored while you were typing the JSON]');
		};
		this.documentoSelezionato = allegato;
		this.dettaglioDoc.emit(this.visualizzaDettagli);
	}
}
